import AppConstant from '../../../../config/app.constants';
import { select, selectAll } from 'd3-selection';
import stackedBarChart from 'britecharts/dist/umd/stackedBar.min.js';
import 'britecharts/dist/css/britecharts.min.css';
import miniTooltip from 'britecharts/dist/umd/miniTooltip.min';
import tooltip from 'britecharts/dist/umd/tooltip.min';
import donutChart from 'britecharts/dist/umd/donut.min.js'
import legend from 'britecharts/dist/umd/legend.min.js'
import bar from 'britecharts/dist/umd/bar.min.js'
import line from 'britecharts/dist/umd/line.min.js'

class BranchPerformanceController {
  /*@ngInject*/
  constructor(Auth, User, UserBranchService, $q, $translate, RouteService, BranchPerformanceService, $filter, ReportService, $rootScope) {
    this.Auth = Auth;
    this.User = User;
    this.UserBranchService = UserBranchService;
    this.$q = $q;
    this.$translate = $translate;
    this.RouteService = RouteService;
    this.BranchPerformanceService = BranchPerformanceService;
    this.$filter = $filter;
    this.ReportService = ReportService;
    this.$rootScope = $rootScope;
    this.model = {
      stats: 'branch',
      tab: 'routes',
      dateRangeOption: {
        startDate: null,
        endDate: null,
      },
      dateRangPickerOptions: {},
      dateRangPickerOptionsfor: {},
      loggedInUser: User.getUser().id,
      userBranchList: [],
      selectedBranch: '',
      totalBranches: 0,
      totalRoutes: 0,
      routeList: [],
      messenger: '',
      messengerList: [],
      totalMessenger: 0,
      loadRouteList: false,
      selectedRouteType: null,
      selectedOrderType: null,
      selectedAccount: null,
      selectedOrderStatus: null,
      gettingRouteStat: false,
      routeStats: {},
      gettingRoutePerformanceStat: false,
      actionCodes: [],
      selectedServiceStatus: null,
      selectedActionCode: null,
      currentBranch: this.User.getUser().branchId,
      gettingRouteLocationStat: false
    };

    this.stats = {
      branch: 'branch',
      all: 'all'
    }

    this.tabs = {
      routes: 'routes',
      orders: 'orders',
      services: 'services'
    }

    this.localLang = {
      selectAll: this.$translate.instant('common.selectall'),
      selectNone: this.$translate.instant('common.selectnone'),
      reset: this.$translate.instant('shipmentBatch.reset'),
      search: this.$translate.instant('common.search'),
      nothingSelected: this.$translate.instant('branch.all_branches'),  //default-label is deprecated and replaced with this.
    }

    this.allRouteTypes = [
      {
        key: 'Regular Routes',
        value: false
      },
      {
        key: 'Event Routes',
        value: true
      }
    ];

    this.allAccounts = [
      {
        key: 'Regular',
        value: 'regular'
      },
      {
        key: 'Emergency',
        value: 'emergency'
      }
    ];

    this.allOrderTypes = [
      {
        key: 'Adds',
        value: 'A'
      },
      {
        key: 'Swaps',
        value: 'S'
      },
      {
        key: 'ICLs',
        value: 'I'
      },
      {
        key: 'CCLs',
        value: 'C'
      },
      {
        key: 'Recashes',
        value: 'R'
      },
      {
        key: 'Permanent Decash',
        value: 'P'
      },
      {
        key: 'Temp Decash',
        value: 'T'
      }
    ];

    this.allOrderStatuses = [
      {
        key: 'Loaded',
        value: 'loaded'
      },
      {
        key: 'CRVed',
        value: 'CRVed'
      },
      {
        key: 'Short-Loaded',
        value: 'shortLoaded'
      },
      {
        key: 'Cancelled',
        value: 'cancelled'
      },
      {
        key: 'Deleted (not CRV deleted)',
        value: 'deleted'
      }
    ]

    this.allServiceStatuses = [
      {
        key: 'Unassigned',
        value: 'unassigned'
      },
      {
        key: 'Pending Route Assign',
        value: 'pendingRouteAssign'
      },
      {
        key: 'Assigned',
        value: 'ASSIGNED'
      },
      {
        key: 'On Route',
        value: 'ON_ROUTE'
      },
      {
        key: 'On Site',
        value: 'ON_SITE'
      },
      {
        key: 'Hold',
        value: 'HOLD'
      },
      {
        key: 'Hold Parts',
        value: 'HOLD_PARTS'
      },
      {
        key: 'Completed',
        value: 'COMPLETE'
      },
      {
        key: 'Cancelled',
        value: 'CANCELLED'
      }
    ];

    this.intervalList = [
      {
        key: 'Min',
        value: 'min'
      },
      {
        key: 'Minute',
        value: 'minute'
      },
      {
        key: 'Hour',
        value: 'hour'
      },
      {
        key: 'Hourly',
        value: 'hourly'
      },
      {
        key: 'Day',
        value: 'day'
      },
      {
        key: 'Daily',
        value: 'daily'
      },
      {
        key: 'Week',
        value: 'week'
      },
      {
        key: 'Weekly',
        value: 'weekly'
      },
      {
        key: 'Month',
        value: 'month'
      },
      {
        key: 'Monthly',
        value: 'monthly'
      },
      {
        key: 'Year',
        value: 'year'
      },
      {
        key: 'Yearly',
        value: 'yearly'
      }
    ];

    this.donutChartDataObj = {};
    this.barChartDataObj = {};
    this.routeList = [];
    this.vehicleList = [];
    this.messengerList = [];
    this.bucketObj = {
      routePerformance: {
        bucketExpanded: true
      },
      routeLocationPerformance: {
        bucketExpanded: true
      },
      ledgerActivityReport: {
        bucketExpanded: true
      },
      loadCompletedActivity: {
        bucketExpanded: true
      },
      residualCompletedActivity: {
        bucketExpanded: true
      },
      deliveryCompletedActivity: {
        bucketExpanded: true
      },
      pickupCompletedActivity: {
        bucketExpanded: true
      },
      bagoutCompletedActivity: {
        bucketExpanded: true
      },
      serviceOrderCompletedActivity: {
        bucketExpanded: true
      },
      serviceOrderCancelledActivity: {
        bucketExpanded: true
      }
    }

    this.ordersGraphList = [{
      label: 'Ledger Activity Report',
      value: 'ledgerActivityReport',
      results: [],
      loading: false
    },
    {
      label: 'Load Completed Activity',
      value: 'loadCompletedActivity',
      results: [],
      loading: false
    },
    {
      label: 'Residual Completed Activity',
      value: 'residualCompletedActivity',
      results: [],
      loading: false
    },
    {
      label: 'Delivery Completed Activity',
      value: 'deliveryCompletedActivity',
      results: [],
      loading: false
    },
    {
      label: 'Pickup Completed Activity',
      value: 'pickupCompletedActivity',
      results: [],
      loading: false
    },
    {
      label: 'Bagout Completed Activity',
      value: 'bagoutCompletedActivity',
      results: [],
      loading: false
    }];

    this.serviceOrdersGraphList = [{
      label: 'Service Order Completed Activity',
      value: 'serviceOrderCompletedActivity',
      results: [],
      loading: false
    },
    {
      label: 'Service Order Cancelled Activity',
      value: 'serviceOrderCancelledActivity',
      results: [],
      loading: false
    }];
    this.$rootScope.$broadcast('routeChange', '/app/branch-management/branch-performance');
  }

  $onInit() {
    this.loadUserBranches('', 0)
      .then((data) => {
        this.setDateRangeOptions(this.currentVaultDate, 'dateRangPickerOptionsfor');
        this.model.dateRangeOption.startDate = moment(this.currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss');
        this.model.dateRangeOption.endDate = moment(this.currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss');
        // this.getRouteMessenger('', 0);
        this.loadData();
        // this.createLineChart();
      })
  }

  createDonutChart() {
    setTimeout(() => {
      this.donutChartDataObj.extraInfo.graphList.forEach((obj, index) => {
        let selector = '.js-donut-chart-container-' + obj.value;
        let donut = donutChart(),
          donutContainer = select(selector),
          containerWidth = donutContainer.node() ? donutContainer.node().getBoundingClientRect().width : false,
          legendChart = legend(),
          legendContainer,
          legendChartHeight = this.model.tab === 'routes' ? 100 : 170;

        if (containerWidth) {
          let dataset = this.donutChartDataObj[obj.value];

          donut
            .isAnimated(true)
            .highlightSliceById(1)
            // .emptyDataConfig({ showEmptySlice: true, emptySliceColor: 'rgb(57 194 201)' })
            .hasFixedHighlightedSlice(true)
            .width(containerWidth)
            .height(containerWidth / 1.2)
            .externalRadius(containerWidth / 2.5)
            .internalRadius(containerWidth / 5)
            .percentageFormat('.1f')
            .on('customMouseOver', function (data) {
              legendChart.highlight(data.data.id);
            })
            .on('customMouseOut', function () {
              // legendChart.highlight(1);
              legendChart.clearHighlight();
            });

          donutContainer.datum(dataset).call(donut);

          legendChart
            .width(300)
            .height(legendChartHeight)

          if (obj.value === 'avgLoaded') {
            legendChart.numberFormat('$,')
          }
          else {
            legendChart.numberFormat('')
          }
          legendContainer = select('.js-legend-chart-container-' + obj.value);
          legendContainer.datum(dataset).call(legendChart)
        }
      })
    }, 500);
  }

  createBarChart() {
    setTimeout(() => {
      this.barChartDataObj.extraInfo.graphList.forEach((obj, index) => {
        let barChart = bar(),
          chartTooltip = miniTooltip(),
          margin = {
            left: this.model.tab === 'routes' ? 70 : 30,
            right: 20,
            top: 10,
            bottom: 30
          },
          barContainer = select('.js-bar-chart-tooltip-container'),
          containerWidth = barContainer.node() ? barContainer.node().getBoundingClientRect().width : false,
          tooltipContainer,
          dataObj = {},
          barChartHeight = this.model.tab === 'routes' ? 387 : 457;

        if (containerWidth) {
          let dataset = this.barChartDataObj[obj.value];

          dataset.forEach((d) => {
            if (obj.value === 'avgRouteTime') {
              let hour = moment.duration(d.value).asHours().toFixed(0)
              dataObj[hour] = d.value;
              d.value = hour;
            } else if (obj.value === 'avgStopTime') {
              let minutes = moment.duration(d.value).asMinutes().toFixed(0)
              dataObj[minutes] = d.value;
              d.value = minutes;
            }
          })

          barChart
            .isHorizontal(true)
            .isAnimated(true)
            .margin(margin)
            .width(containerWidth)
            // .colorSchema(britecharts.colors.colorSchemas.green)
            // .valueLabel('percentage')
            // .labelsNumberFormat('.0%')
            .percentageAxisToMaxRatio(1.1)
            .height(barChartHeight)
            .on('customMouseOver', chartTooltip.show)
            .on('customMouseMove', chartTooltip.update)
            .on('customMouseOut', chartTooltip.hide);

          barContainer.datum(dataset).call(barChart);

          tooltipContainer = select('.bar-chart .metadata-group');
          chartTooltip.valueFormatter((value) => dataObj[value]);
          tooltipContainer.datum([]).call(chartTooltip);
        }
      })
    }, 500)
  }

  redrawChart() {
    selectAll('.donut-chart').remove();
    selectAll('.britechart-legend').remove();
    this.createDonutChart();
    if (this.model.tab !== 'services') {
      this.createBarChart();
    }
  };

  stateSelection(selectedValue) {
    this.model.stats = selectedValue;
  }

  tabSelection(selectedValue) {
    this.model.tab = selectedValue;
    // selectAll('.donut-chart').remove();
    // selectAll('.britechart-legend').remove();
    this.loadData();
  }

  setDateRangeOptions(date, modelValue) {
    let currentVaultDate = moment(date).format() || moment();
    this.model[modelValue] = {
      autoApply: true,
      eventHandlers: {
        'apply.daterangepicker': () => {
          this.resetData();
          this.loadData();
        }
      },
      ranges: {
        'Today': [
          moment(currentVaultDate).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('day').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Week': [
          moment(currentVaultDate).startOf('week').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('week').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Current Month': [
          moment(currentVaultDate).startOf('month').format('YYYY-MM-DD HH:mm:ss'),
          moment(currentVaultDate).endOf('month').format('YYYY-MM-DD HH:mm:ss')
        ],
        'Past 30': [
          moment(currentVaultDate).subtract(29, 'days').format('YYYY-MM-DD HH:mm:ss')
        ],
        // 'Past 60': [
        //   moment(currentVaultDate).subtract(59, 'days').format('YYYY-MM-DD HH:mm:ss')
        // ],
        // 'Past 90': [
        //   moment(currentVaultDate).subtract(89, 'days').format('YYYY-MM-DD HH:mm:ss')
        // ],
        // 'Current Year': [
        //     moment(currentVaultDate).startOf('year').format('YYYY-MM-DD HH:mm:ss'),
        //     moment(currentVaultDate).endOf('year').format('YYYY-MM-DD HH:mm:ss')
        // ]
      }
    }
  }

  loadUserBranches(searchKey, offset) {
    searchKey = searchKey || '';
    return this.UserBranchService.getUserBranches(this.model.loggedInUser)
      .then((data) => {
        if (offset === 0 || offset == undefined) {
          this.model.totalBranches = data.results.length;
          this.model.userBranchList = this.userBranchMap(data.results);
        }
        else {
          const branches = this.userBranchMap(data.results);
          this.model.userBranchList = this.model.userBranchList.concat(branches);
        }
        this.model.userBranchList.filter((branch) => {
          if (branch.Key == this.model.currentBranch) {
            branch.ticked = true;
          }
        })
      })
      .catch((err) => {
        console.log(err);
      });
  }

  userBranchMap(branches) {
    return branches.map((branch) => {
      return {
        Key: branch.branchId,
        Value: branch.branchId,
      }
    });
  }

  messengerMapping(array) {
    return array.map((obj) => {
      return {
        Key: obj.messengerId + ' (' + obj.messengerName + ')',
        Value: obj.messengerId
      }
    });
  }

  getRoutePerformance() {
    const key = 'route-performance';
    this.isRoutePerformanceRecordFound = true;
    this.loadContainer(key);

    setTimeout(() => {
      this.model.gettingRoutePerformanceStat = true;
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const reverseSort = false;
      const route = [];
      const dataSet = [];
      const statsList = [
        {
          label: 'Avg Time | Checkout',
          value: 'avgTimeCheckinStartSec'
        },
        {
          label: 'Avg Time | On Route',
          value: 'avgTimeOutOfBranchSec'
        },
        {
          label: 'Avg Time | Load',
          value: 'avgTimeLoadSec'
        },
        {
          label: 'Avg Time | Start Route',
          value: 'avgTimeLoadStartSec'
        },
        {
          label: 'Avg Time | Route',
          value: 'avgTimeCycleSec'
        }]

      return this.ReportService.routePerformance(startDate, endDate, groupInterval, reverseSort, branchIds, route, groupBy, 500, 0)
        .then((data) => {
          this.model.routePerformanceStats = data.results;
          if (this.model.routePerformanceStats.length) {
            this.generateStackedBarChart(this.model.routePerformanceStats, statsList, key, 'Route Performance', this.model.tab);
          }
          else {
            this.removeLoadingContainer(key);
            this.isRoutePerformanceRecordFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.model.gettingRoutePerformanceStat = false;
        })
    }, 500)
  }

  getRouteLocationPerformance() {
    const key = 'route-location-performance';
    this.isRouteLocationRecordFound = true;
    this.loadContainer(key);

    setTimeout(() => {
      this.model.gettingRouteLocationStat = true;
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const reverseSort = false;
      const route = [];

      const statsList = [{
        label: 'Avg Time | To Customer',
        value: 'avgTimeToCustomerSec'
      },
      {
        label: 'Avg Time | AT Customer',
        value: 'avgTimeAtCustomerSec'
      },
      {
        label: 'Avg Time | To Truck',
        value: 'avgTimeToTruckSec'
      },
        // {
        //   label: 'Number Of Stops',
        //   value: 'numberOfStops'
        // }
      ];

      return this.ReportService.routeLocationPerformance(startDate, endDate, groupInterval, reverseSort, branchIds, route, groupBy, 500, 0)
        .then((data) => {
          this.model.routeLocationStats = data.results;
          if (this.model.routeLocationStats.length) {
            this.generateStackedBarChart(this.model.routeLocationStats, statsList, key, 'Route Location Performance', this.model.tab);
          }
          else {
            this.removeLoadingContainer(key);
            this.isRouteLocationRecordFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.model.gettingRouteLocationStat = false;
        })
    }, 500)
  }

  loadData() {
    selectAll('.stacked-bar').remove();
    if (this.model.tab === 'routes') {
      this.getRoutePerformance();
      this.getRouteLocationPerformance();
    }
    else if (this.model.tab === 'orders') {
      this.getLedgerActivityReport();
      this.getLoadCompletedActivity();
      this.getDeliveryCompletedActivity();
      this.getResidualCompletedActivity();
      this.getPickupCompletedActivity();
      this.getBagoutCompletedActivity();
    }
    else if (this.model.tab === 'services') {
      this.getServiceOrderCompletedActivity();
      this.getServiceOrderCancelledActivity();
    }
  }

  resetRouteFilter() {
    this.model.messenger = null;
  }

  resetData() {
    if (this.model.tab === 'routes') {
      this.resetRouteFilter();
    }
  }

  getLedgerActivityReport() {
    const obj = _.find(this.ordersGraphList, { 'value': 'ledgerActivityReport' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const denomination = [];
      const fundingSource = [];
      const account = [];
      const currency = ['USD'];

      const statsList = [
        {
          label: 'Total | System Adjust',
          value: 'totalSystemAdjust'
        },
        {
          label: 'Total | User Adjust',
          value: 'totalUserAdjust'
        },
        {
          label: 'Total Amount',
          value: 'totalAmount'
        }]

      obj.loading = true;
      return this.ReportService.ledgerActivityReport(startDate, endDate, groupInterval, groupBy, account, branchIds, fundingSource, currency, denomination, 500, 0)
        .then((data) => {
          this.model.ledgerActivityReportData = data.results;
          obj.results = this.model.ledgerActivityReportData;
          if (this.model.ledgerActivityReportData.length) {
            this.generateStackedBarChart(this.model.ledgerActivityReportData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getLoadCompletedActivity() {
    const obj = _.find(this.ordersGraphList, { 'value': 'loadCompletedActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const denomination = [];
      const fundingSource = [];
      const currency = ['USD'];
      const location = [];
      const route = [];

      const statsList = [
        // {
        //   label: 'Avg Time | To Deliver',
        //   value: 'avgTimeToDeliverSec'
        // },
        {
          label: 'Total Amount',
          value: 'totalAmount'
        }]

      obj.loading = true;
      return this.ReportService.loadCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fundingSource, location, currency, denomination, 500, 0)
        .then((data) => {
          this.model.loadCompletedActivityData = data.results;
          obj.results = this.model.loadCompletedActivityData;
          if (this.model.loadCompletedActivityData.length) {
            this.generateStackedBarChart(this.model.loadCompletedActivityData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getDeliveryCompletedActivity() {
    const obj = _.find(this.ordersGraphList, { 'value': 'deliveryCompletedActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const shiptype = [];
      const toLocation = [];
      const fromLocation = [];
      const route = [];

      const statsList = [
        // {
        //   label: 'Avg Time | To Deliver',
        //   value: 'avgTimeToDeliverSec'
        // },
        {
          label: 'Total Amount',
          value: 'totalAmount'
        }]

      obj.loading = true;
      return this.ReportService.deliveryCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fromLocation, toLocation, shiptype, 500, 0)
        .then((data) => {
          this.model.deliveryCompletedActivityData = data.results;
          obj.results = this.model.deliveryCompletedActivityData;
          if (this.model.deliveryCompletedActivityData.length) {
            this.generateStackedBarChart(this.model.deliveryCompletedActivityData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getResidualCompletedActivity() {
    const obj = _.find(this.ordersGraphList, { 'value': 'residualCompletedActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const route = [];
      const fundingSource = [];
      const location = [];
      const currency = [];
      const denomination = [];

      const statsList = [
        {
          label: 'Total Amount | Load Requested',
          value: 'totalAmountLoadRequested'
        },
        {
          label: 'Total Amount | Load Actual',
          value: 'totalAmountLoadActual'
        },
        {
          label: 'Total Amount | Expected',
          value: 'totalAmountExpected'
        },
        {
          label: 'Total CRV',
          value: 'totalCRV'
        },
        {
          label: 'Total Amount | Counted',
          value: 'totalAmountCounted'
        },
        {
          label: 'Total Variance',
          value: 'totalVariance'
        }]

      obj.loading = true;
      return this.ReportService.residualCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fundingSource, location, currency, denomination, 500, 0)
        .then((data) => {
          this.model.residualCompletedActivityData = data.results;
          obj.results = this.model.residualCompletedActivityData;
          if (this.model.residualCompletedActivityData.length) {
            this.generateStackedBarChart(this.model.residualCompletedActivityData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getPickupCompletedActivity() {
    const obj = _.find(this.ordersGraphList, { 'value': 'pickupCompletedActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const shiptype = [];
      const toLocation = [];
      const fromLocation = [];
      const route = [];

      const statsList = [{
        label: 'Total Amount',
        value: 'totalAmount'
      }]

      obj.loading = true;
      return this.ReportService.pickupCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, route, fromLocation, toLocation, shiptype, 500, 0)
        .then((data) => {
          this.model.pickupCompletedActivityData = data.results;
          obj.results = this.model.pickupCompletedActivityData;
          if (this.model.pickupCompletedActivityData.length) {
            this.generateStackedBarChart(this.model.pickupCompletedActivityData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getBagoutCompletedActivity() {
    const obj = _.find(this.ordersGraphList, { 'value': 'bagoutCompletedActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const shiptype = [];
      const toLocation = [];
      const fromLocation = [];
      const carrier = [];

      const statsList = [{
        label: 'Total Amount',
        value: 'totalAmount'
      }]

      obj.loading = true;
      return this.ReportService.bagoutCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, carrier, fromLocation, toLocation, shiptype, 500, 0)
        .then((data) => {
          this.model.bagoutCompletedActivityData = data.results;
          if (this.model.bagoutCompletedActivityData.length) {
            this.model.bagoutCompletedActivityData = this.findDuplicateEntry(this.model.bagoutCompletedActivityData, 'date', 'totalAmount');
            obj.results = this.model.bagoutCompletedActivityData.filter(d => !d.matchPreviousRow);

            this.generateStackedBarChart(obj.results, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getServiceOrderCompletedActivity() {
    const obj = _.find(this.serviceOrdersGraphList, { 'value': 'serviceOrderCompletedActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const location = [];
      const route = [];
      const user = [];
      const externalProcessor = [];

      const statsList = [{
        label: 'Avg Time | Open',
        value: 'avgTimeOpenSec'
      }]

      obj.loading = true;
      return this.ReportService.serviceOrderCompletedActivity(startDate, endDate, groupInterval, groupBy, branchIds, location, route, user, externalProcessor, 500, 0)
        .then((data) => {
          this.model.serviceOrderCompletedActivityData = data.results;
          obj.results = this.model.serviceOrderCompletedActivityData;
          if (this.model.serviceOrderCompletedActivityData.length) {
            this.generateStackedBarChart(this.model.serviceOrderCompletedActivityData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  getServiceOrderCancelledActivity() {
    const obj = _.find(this.serviceOrdersGraphList, { 'value': 'serviceOrderCancelledActivity' });
    obj.isRecordsFound = true;
    this.loadContainer(obj.value);

    setTimeout(() => {
      const startDate = moment(this.model.dateRangeOption.startDate).format('YYYY-MM-DD');
      const endDate = moment(this.model.dateRangeOption.endDate).format('YYYY-MM-DD');
      const branchIds = this.model.selectedBranch.length ? this.model.selectedBranch.map(b => b.Key) : null;
      const groupInterval = this.model.selectedInterval ? this.model.selectedInterval : null;
      const groupBy = ['branch'];
      const location = [];
      const route = [];
      const user = [];
      const externalProcessor = [];

      const statsList = [{
        label: 'Avg Time | Open',
        value: 'avgTimeOpenSec'
      }]

      obj.loading = true;
      return this.ReportService.serviceOrderCancelledActivity(startDate, endDate, groupInterval, groupBy, branchIds, location, route, user, externalProcessor, 500, 0)
        .then((data) => {
          this.model.serviceOrderCancelledActivityData = data.results;
          obj.results = this.model.serviceOrderCancelledActivityData;
          if (this.model.serviceOrderCancelledActivityData.length) {
            this.generateStackedBarChart(this.model.serviceOrderCancelledActivityData, statsList, obj.value, obj.label, this.model.tab);
          }
          else {
            this.removeLoadingContainer(obj.value);
            obj.isRecordsFound = false;
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          obj.loading = false;
        })
    }, 500)
  }

  translateStatus(statusCode) {
    return this.$translate.instant('serviceTickets.status_' + statusCode)
  }

  getOrderType(orderType) {
    return this.$translate.instant('shipment.order_type_' + orderType);
  }

  convertSecToHMS(seconds) {
    seconds = Number(seconds);
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = Math.floor(seconds % 3600 % 60);

    const hDisplay = h > 0 ? h + (":") : '00' + ':';
    const mDisplay = m > 0 ? m + (":") : '00' + ':';
    const sDisplay = s > 0 ? s : '00';

    return hDisplay + mDisplay + sDisplay;
  }

  validateBucket(stat) {
    this.bucketObj[stat].bucketExpanded = !this.bucketObj[stat].bucketExpanded;
  }

  createStackedBarChart(data, stat, title, currentTab) {
    var chart = stackedBarChart(),
      chartTooltip = tooltip(),
      selector = `.js-stacked-bar-chart-tooltip-container-${stat}`,
      selectorLoading = `.js-loading-container-${stat}`,
      container = select(selector),
      containerWidth = container.node() ? container.node().getBoundingClientRect().width : false,
      tooltipContainer,
      dataset,
      margin = {
        left: 0,
        right: 20,
        top: 50,
        bottom: 30
      };

    if (containerWidth) {
      $(selectorLoading).empty();
      dataset = { data: data };
      chart
        .tooltipThreshold(600)
        // .aspectRatio(0.5)
        .height(400)
        .width(containerWidth)
        .margin(margin)
        .grid('horizontal')
        .isAnimated(true)
        .stackLabel('stack')
        .nameLabel('date')
        // .betweenBarsPadding(0.8)
        // .nameLabelFormat('')
        // .xTicks(1)
        .valueLabel('views')
        // .valueLabelFormat(',f')
        // .yAxisLabel('ferfer')
        .colorSchema([
          '#6aedc7', //green
          '#39c2c9', //blue
          '#ffce00', //yellow
          '#ffa71a', //orange
          '#ff938c', //red
        ])
        .on("customMouseOver", chartTooltip.show)
        .on('customMouseMove', chartTooltip.update)
        .on("customMouseOut", chartTooltip.hide);

      container.datum(dataset.data).call(chart);

      // dataset.data.map((obj, index) => {
      //   if (currentTab === this.tabs.routes) {
      //     // obj.stack.startsWith('Avg') ? chartTooltip.valueFormatter((value) => moment.utc(value * 1000).format('HH:mm:ss')) : obj.value;
      //     obj.views = obj.stack.startsWith('Avg') ? moment.utc(obj.views * 1000).format('HH:mm:ss') : obj.views;
      //     obj.value = obj.stack.startsWith('Avg') ? moment.utc(obj.value * 1000).format('HH:mm:ss') : obj.value;
      //   }
      //   else if (currentTab === this.tabs.orders) {
      //     // obj.stack.startsWith('Avg') ? chartTooltip.valueFormatter((value) => moment.utc(value * 1000).format('HH:mm:ss')) : chartTooltip.valueFormatter((value) => this.$filter('currency')(value, '$', 0));;
      //     obj.views = obj.stack.startsWith('Avg') ? moment.utc(obj.views * 1000).format('HH:mm:ss') : this.$filter('currency')(obj.views, '$', 0);
      //   }
      // })

      chartTooltip
        .topicLabel('values')
        .dateLabel('key')
        .nameLabel('stack')
        .title(title)

      tooltipContainer = select(`.js-stacked-bar-chart-tooltip-container-${stat} .metadata-group`);
      tooltipContainer.datum([]).call(chartTooltip);
      if (currentTab === this.tabs.routes || currentTab === this.tabs.services) chartTooltip.valueFormatter((value) => moment.utc(value * 1000).format('HH:mm:ss'));
      else if (currentTab === this.tabs.orders) chartTooltip.valueFormatter((value) => this.$filter('currency')(value, '$', 0));
    }
  }

  generateStackedBarChart(statsData, statsList, currentStat, title, currentTab) {
    const dataSet = [];
    statsData.forEach((d) => {
      statsList.forEach((stat) => {
        dataSet.push({
          stack: stat.label,
          date: d.date,
          views: currentStat === 'ledgerActivityReport' ? Math.abs(d[stat.value]) : d[stat.value]
        })
      })
    })

    setTimeout(() => {
      this.createStackedBarChart(dataSet, currentStat, title, currentTab);
    }, 500);
  }

  findDuplicateEntry(item, sortBy, col) {
    let list = item;
    let sortByKey = sortBy;

    list = _.sortBy(list, [sortByKey]);
    list[0].matchPreviousRow = false;

    for (var i = 0; i < list.length; i++) {
      let date = list[i][sortByKey];
      var cursor = 1;

      for (var j = i + 1; j < list.length; j++) {
        if (list[j][sortByKey] === date && !list[j].matchPreviousRow) {
          cursor++;
          list[j].matchPreviousRow = true;
          if (col) list[i][col] += list[j][col]
        }
        else {
          break;
        }
      }
      list[i].cursor = cursor;
    }
    return list;
  }

  loadContainer(stat) {
    let selector = `.js-loading-container-${stat}`;
    let stackedBar = stackedBarChart(),
      stackedBarContainer = select(selector),
      containerWidth = stackedBarContainer.node() ? stackedBarContainer.node().getBoundingClientRect().width : false;
    if (containerWidth) {
      stackedBarContainer.html(stackedBar.loadingState())
    }
  }

  removeLoadingContainer(stat) {
    let selector = `.js-loading-container-${stat}`;
    $(selector).empty();
  }

}

export default BranchPerformanceController;



// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/branch_performance/branch_performance.controller.js